import { render, staticRenderFns } from "./FollowedCompanies.vue?vue&type=template&id=28db4899&scoped=true&"
import script from "./FollowedCompanies.vue?vue&type=script&lang=js&"
export * from "./FollowedCompanies.vue?vue&type=script&lang=js&"
import style0 from "./FollowedCompanies.vue?vue&type=style&index=0&id=28db4899&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db4899",
  null
  
)

export default component.exports